import React, { useContext, useMemo, useState } from "react";
import { useRouteMatch } from "react-router-dom";
import CurrencySelect from "components/inputs/currency_select";
import LocaleSelect from "components/inputs/locale_select";
import HeaderMenu from "components/header/header_menu";
import routes from "routing/routes";

import styles from "./header.module.css";
import { NavDropdown } from "react-bootstrap";
import DummyImage from "assets/images/user.png";
import { BookingDataContext } from "containers/data_context";
import LoginMember from "./member/loginMember";
import UserBookings from "components/user_bookings";
import LanguagesModal from "components/languages_modal/languages_modal";
import { useTranslation } from "react-i18next";
import { MailOutlined } from "@ant-design/icons";
import supportedLanguages from "constants/supported_languages";
import { LANGUAGE } from "constants/storage_keys";

export default function Header({ property = {} }) {
  const { channelId } = useContext(BookingDataContext);
  const { t, i18n } = useTranslation();
  const store = localStorage.getItem(LANGUAGE);

  const currentLanguage = useMemo(() => {
    return supportedLanguages?.find((lng) => store === lng?.key || i18n.language === lng?.key);
  }, [store, i18n]);

  const matchHotelPage = useRouteMatch({
    path: routes.hotelPage,
    strict: true,
  });

  const matchNotFoundPage = useRouteMatch({
    path: routes.default,
    strict: true,
  });

  const isCurrencySelectShown = matchHotelPage?.isExact && !matchNotFoundPage;
  const { title, logo } = property;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const mydata = JSON.parse(localStorage.getItem("userInfo"));
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showUserBooking, setShowUserBooking] = useState(false);

  const handleEmailClick = () => {
    if (property?.email) {
      const email = property?.email;
      const subject = encodeURIComponent("Booking Inquiry");
      const body = encodeURIComponent("Hello, I would like to inquire about booking.");
      const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;

      // Redirect the current tab to the mailto link
      window.location.href = mailtoLink;
    }
  };

  const [showLanguagesModal, setShowLanguagesModal] = useState(false);

  return (
    <header className={`${styles.header} `}>
      <div className={styles.logoSection}>
        {showLoginModal && (
          <LoginMember
            property={property}
            channelId={channelId}
            setMember={setShowLoginModal}
            member={showLoginModal}
          ></LoginMember>
        )}
        {showUserBooking && (
          <UserBookings
            showModal={showUserBooking}
            userData={mydata}
            setShowModal={setShowUserBooking}
            channelId={channelId}
          />
        )}
        <LanguagesModal showModal={showLanguagesModal} setShowModal={setShowLanguagesModal} />
        <div className={styles.hotelLogo}>
          <div className={styles.logoContainer}>
            <img className={styles.logo} src={logo ? logo : "../../logo.jpg"} alt={title} />
          </div>
        </div>

        <div className={styles.menuIcon}>
          {isCurrencySelectShown && <CurrencySelect />}

          <div onClick={() => setShowLanguagesModal(true)} className={styles.language_label}>
            <img src={currentLanguage?.img} style={{ width: 20, height: 20 }} />
            <span className="ml-1">⏷</span>
          </div>
          {property?.email && (
            <div className={styles.language_label} onClick={handleEmailClick}>
              <MailOutlined />
            </div>
          )}
        </div>
      </div>
      <div className={`d-flex align-items-center `}>
        <div className={`${styles.menuLinks} `}>
          <HeaderMenu property={property} />
        </div>

        <div className={`${styles.selectSection} `}>
          <div className={styles.lang}>
            {isCurrencySelectShown && <CurrencySelect />}

            <div onClick={() => setShowLanguagesModal(true)} className={styles.language_label}>
              {t("general:locale")} <span className="ml-1">⏷</span>
            </div>
            <div className={styles.custom_dropdown1}>
              {mydata && mydata?.channelId === channelId ? (
                <NavDropdown
                  className="custom-dropdown"
                  style={{ color: "white" }}
                  title={<img src={DummyImage} className={styles.image} alt="User Icon" />}
                  id="basic-nav-dropdown"
                >
                  <NavDropdown.Item
                    as={() => {
                      // Your user information component goes here
                      return (
                        <div>
                          <div className={styles.name}>
                            {mydata?.name}
                            <sup className={styles.memberBadge}>{mydata?.login_type}</sup>
                          </div>

                          {/* <div className={styles.actionText}>Your Discount {mydata?.discount}%</div> */}
                        </div>
                      );
                    }}
                  >
                    Profile
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={() => {
                      // Your user information component goes here
                      return (
                        <div onClick={() => setShowUserBooking(true)}>
                          <div className={`${styles.name} ${styles.actionText}`}>My Bookings</div>

                          {/* <div className={styles.actionText}>Your Discount {mydata?.discount}%</div> */}
                        </div>
                      );
                    }}
                  >
                    My Bookings
                  </NavDropdown.Item>
                  {/* <NavDropdown.Item href="#settings">Settings</NavDropdown.Item> */}
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    as={() => (
                      <div
                        className={styles.logout}
                        onClick={() => {
                          localStorage.removeItem("userInfo");
                          window.location.reload();
                        }}
                      >
                        Logout
                      </div>
                    )}
                  />
                </NavDropdown>
              ) : (
                <img
                  onClick={() => setShowLoginModal(true)}
                  src={DummyImage}
                  className={styles.image}
                  alt="User Icon"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
